// import React, { useState } from "react";
// import "../Styles/EnquirePopup.css";

// const EnquirePopup = ({ isOpen, onClose }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form Submitted:", formData);
//     onClose(); // close popup after submit
//   };

//   if (!isOpen) return null; // hide when not open

//   return (
//     <div className="EnquirePopUp-overlay">
//       <div className="EnquirePopUp-container">
//         <button className="EnquirePopUp-close" onClick={onClose}>
//           ✕
//         </button>
//         <h2 className="EnquirePopUp-title">Enquire Now</h2>
//         <form className="EnquirePopUp-form" onSubmit={handleSubmit}>
//           <div className="EnquirePopUp-input-row">
//             <input
//               className="EnquirePopUp-name-input"
//               type="text"
//               name="name"
//               placeholder="Name*"
//               value={formData.name}
//               onChange={handleChange}
//               required
//             />
//             <input
//               className="EnquirePopUp-name-input"
//               type="text"
//               name="phone"
//               placeholder="Phone number"
//               value={formData.phone}
//               onChange={handleChange}
//             />
//           </div>
//           <input
//             className="EnquirePopUp-name-email"
//             type="email"
//             name="email"
//             placeholder="E-mail*"
//             value={formData.email}
//             onChange={handleChange}
//             required
//           />
//           <textarea
//             name="message"
//             placeholder="Your Message"
//             value={formData.message}
//             onChange={handleChange}
//           ></textarea>
//           <button type="submit" className="EnquirePopUp-send-btn">
//             SEND
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EnquirePopup;

import React, { useState } from "react";
import "../Styles/EnquirePopup.css";
import { trackLeadSubmit } from "../utils/Tracking";

const EnquirePopup = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Get source from URL parameter 's' or default to "80"
    const searchParams = new URLSearchParams(window.location.search);
    const sourceValue = searchParams.get("s") || "80";

    const payload = {
      name: formData.name,
      email: formData.email,
      number: formData.phone,
      "lead-message": formData.message,
      source: sourceValue,
      secret: "norg2021",
    };

    try {
      const response = await fetch("https://krushika.org/crm/endpoint.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.text();
      console.log("Server Response:", result);
      alert("Form submitted successfully!");
      trackLeadSubmit();

      onClose();
    } catch (error) {
      console.error("Submit Error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="EnquirePopUp-overlay">
      <div className="EnquirePopUp-container">
        <button className="EnquirePopUp-close" onClick={onClose}>
          ✕
        </button>
        <h2 className="EnquirePopUp-title">Enquire Now</h2>
        <form className="EnquirePopUp-form" onSubmit={handleSubmit}>
          <div className="EnquirePopUp-input-row">
            {/* inputs unchanged */}
            <input
              className="EnquirePopUp-name-input"
              type="text"
              name="name"
              placeholder="Name*"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              className="EnquirePopUp-name-input"
              type="text"
              name="phone"
              placeholder="Phone number"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          <input
            className="EnquirePopUp-name-email"
            type="email"
            name="email"
            placeholder="E-mail*"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          <button type="submit" className="EnquirePopUp-send-btn" disabled={isLoading}>
            {isLoading ? "SENDING..." : "SEND"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnquirePopup;
